import { findScrollContainer } from "./findScrollContainer";

/**
 * Esta función calcula el offset que existe entre un elemento y su padre más inmediato que tenga scroll visible
 */
export function findOffsetRelativeToScrollParent(
  element: HTMLElement,
  which: 'Left' | 'Top' = 'Top',
) {
  const scrollParent = findScrollContainer(element);
  let currentElement = element;
  let offset = 0;
  let offsetParent = currentElement;
  while (
    currentElement &&
    currentElement !== scrollParent &&
    currentElement !== document.body &&
    offsetParent !== scrollParent
  ) {
    if (offsetParent !== currentElement.offsetParent) {
      offset += currentElement[`offset${which}`];
      offsetParent = currentElement.offsetParent as HTMLElement;
    }
    currentElement = currentElement.parentElement as HTMLElement;
  }
  return offset;
}